export function contractYears() {
  var years = []

  var currentYear = getCurrentYear()

  // we start creating contracts for the next year in july
  if ((new Date()).getMonth() > 5) {
    currentYear++
  }
  for (var year = 2020; year <= currentYear; year++) {
    years.push({ value: year, text: year + '' })
  }
  return years
}

export function getCurrentYear() {
  return (new Date()).getYear() + 1900
}

// we don't create contracts / kukos for the current year if it's already december
export function getDefaultStartDate() {
  if ((new Date()).getMonth() > 8) {
    return new Date(new Date().getFullYear() + 1, 0, 1)
  }
  return new Date(new Date().getFullYear(), 0, 1)
}

export function getDefaultEndDate() {
  if ((new Date()).getMonth() > 8) {
    return new Date(new Date().getFullYear() + 1, 11, 31)
  }
  return new Date(new Date().getFullYear(), 11, 31)
}
